import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";


export class FRFCExpression extends FRBase{
    private FunctionName:string;
    private Args:FRBase[];
    constructor(Options: any, Parent: FRBase) {
        super(Options, Parent);

        this.FunctionName=this.Options.Fn;
        this.Args=[];
        this.Options.Ar.forEach(x=>this.Args.push(FRFactory.GetFRElement(x,this)));

    }

    Parse(): any {
        let args=[];
        return this.Iterate(this.Args,item => {
            args.push(item);
        },()=>{
            return this.Retriever.CallFunction(this.FunctionName,args)
        });


    }
}

FRFactory.AddField('FC',FRFCExpression);